module.exports = __webpack_public_path__ + "resources/img/img_tibero4_en.18a76907b16721df7022f4d9b5bac155.png";